import {
  getList,
  getLeoUuid,
  LeoUUID,
} from "@surya-digital/leo-ts-types";
import { ChatSurveyElement } from "./chatSurveyElement";


export namespace ChatSurveyTimelineUpdate {
  export interface ReplaceAllDTO {
    case: string;
    elements: ChatSurveyElement.ChatSurveyElementDTO[];
  }
  
  export class ReplaceAll {
    readonly isChatSurveyTimelineUpdateReplaceAll: boolean = true;
  
    readonly elements: ChatSurveyElement.ChatSurveyElement[];
  
  
    constructor(
    elements: ChatSurveyElement.ChatSurveyElement[]
    ) {
      this.elements = elements;
    }
  
    static fromDTO(dto: ReplaceAllDTO): ReplaceAll {
      const elements = getList<ChatSurveyElement.ChatSurveyElementDTO, ChatSurveyElement.ChatSurveyElement>(
        dto,
        "elements",
        ChatSurveyElement.fromDTO,
        InvalidChatSurveyTimelineUpdateReplaceAllElementsError
      );
      return new ReplaceAll(
        elements
      );
    }
  
    toDTO(): ReplaceAllDTO {
      const dto: ReplaceAllDTO = {
        case: "REPLACE_ALL",
          elements: this.elements.map((e: ChatSurveyElement.ChatSurveyElement) => { return e.toDTO(); })
      };
      return dto;
    }
    }
  
  ReplaceAll.prototype.toString = function toString(): string {
    return `ChatSurveyTimelineUpdate.REPLACE_ALL(elements='${this.elements}')`;
  };
  
  export interface ReplaceFromQuestionDTO {
    case: string;
    questionId: string;
    elements: ChatSurveyElement.ChatSurveyElementDTO[];
  }
  
  export class ReplaceFromQuestion {
    readonly isChatSurveyTimelineUpdateReplaceFromQuestion: boolean = true;
  
    readonly questionId: LeoUUID;
    readonly elements: ChatSurveyElement.ChatSurveyElement[];
  
  
    constructor(
    questionId: LeoUUID, 
    elements: ChatSurveyElement.ChatSurveyElement[]
    ) {
      this.questionId = questionId;
      this.elements = elements;
    }
  
    static fromDTO(dto: ReplaceFromQuestionDTO): ReplaceFromQuestion {
      const questionId = getLeoUuid(dto, "questionId", InvalidChatSurveyTimelineUpdateReplaceFromQuestionQuestionIdError);
      const elements = getList<ChatSurveyElement.ChatSurveyElementDTO, ChatSurveyElement.ChatSurveyElement>(
        dto,
        "elements",
        ChatSurveyElement.fromDTO,
        InvalidChatSurveyTimelineUpdateReplaceAllElementsError
      );
      return new ReplaceFromQuestion(
        questionId,
        elements
      );
    }
  
    toDTO(): ReplaceFromQuestionDTO {
      const dto: ReplaceFromQuestionDTO = {
        case: "REPLACE_FROM_QUESTION",
          questionId: this.questionId.toDTO(),
          elements: this.elements.map((e: ChatSurveyElement.ChatSurveyElement) => { return e.toDTO(); })
      };
      return dto;
    }
    }
  
  ReplaceFromQuestion.prototype.toString = function toString(): string {
    return `ChatSurveyTimelineUpdate.REPLACE_FROM_QUESTION(questionId='${this.questionId}',elements='${this.elements}')`;
  };
  

  export type ChatSurveyTimelineUpdate = ReplaceAll | ReplaceFromQuestion;

  export type ChatSurveyTimelineUpdateDTO = ReplaceAllDTO | ReplaceFromQuestionDTO;

  export const fromDTO = (dto: ChatSurveyTimelineUpdateDTO): ChatSurveyTimelineUpdate => {
    switch (dto.case) {
      case "REPLACE_ALL":
          return ReplaceAll.fromDTO(dto as ReplaceAllDTO);
      case "REPLACE_FROM_QUESTION":
          return ReplaceFromQuestion.fromDTO(dto as ReplaceFromQuestionDTO);
      default:
        throw new InvalidChatSurveyTimelineUpdateError(
            `Case ${dto.case} is not valid case of ChatSurveyTimelineUpdate.`
        );
    }
  };
}

export class InvalidChatSurveyTimelineUpdateError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyTimelineUpdateError";
  }
}
export class InvalidChatSurveyTimelineUpdateReplaceAllError extends InvalidChatSurveyTimelineUpdateError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyTimelineUpdateReplaceAllError";
  }
}

export class InvalidChatSurveyTimelineUpdateReplaceAllElementsError extends InvalidChatSurveyTimelineUpdateReplaceAllError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyTimelineUpdateReplaceAllElementsError";
  }
}

export class InvalidChatSurveyTimelineUpdateReplaceFromQuestionError extends InvalidChatSurveyTimelineUpdateError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyTimelineUpdateReplaceFromQuestionError";
  }
}

export class InvalidChatSurveyTimelineUpdateReplaceFromQuestionQuestionIdError extends InvalidChatSurveyTimelineUpdateReplaceFromQuestionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyTimelineUpdateReplaceFromQuestionQuestionIdError";
  }
}

export class InvalidChatSurveyTimelineUpdateReplaceFromQuestionElementsError extends InvalidChatSurveyTimelineUpdateReplaceFromQuestionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyTimelineUpdateReplaceFromQuestionElementsError";
  }
}
